/* eslint-disable @next/next/no-img-element */

import React from 'react';

import styles from './styles.module.scss'

interface ImageSectionProps {
  image1: string;
  image2: string;
  alt1?: string;
  alt2?: string;
}

export default function ImagesSection({ image1, image2, alt1, alt2 } : ImageSectionProps)  {
  return (
    <div className={`${styles.imageSection} cooler-padding`}>
      <div className={styles.imageHolder}>
        <img className={styles.image} src={image1} alt={alt1} />
      </div>

      <div className={styles.imageHolder}>
        <img className={styles.image} src={image2} alt={alt2} />
      </div>
    </div>
  )
};
